import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { Empty_LetterRequestCustomer_ScheduleTable_Interface, LetterRequestCustomer_ScheduleTable_Interface } from 'src/app/Interface/LetterRequestCustomer_ScheduleTable_Interface';
import { Empty_LetterRequestCustomer_Schedule_Interface, LetterRequestCustomer_Schedule_Interface } from 'src/app/Interface/LetterRequestCustomer_Schedule_Interface';
import { Empty_Letter_Interface, Letter_Interface } from 'src/app/Interface/Letter_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';

@Component({
  selector: 'app-LetterRequestCustomerScheduleForm',
  templateUrl: './LetterRequestCustomerScheduleForm.component.html',
  styleUrls: ['./LetterRequestCustomerScheduleForm.component.scss']
})
export class LetterRequestCustomerScheduleFormComponent implements OnInit {

  @Input() inner_Record: LetterRequestCustomer_ScheduleTable_Interface = Empty_LetterRequestCustomer_ScheduleTable_Interface()
  Token: String = ""
  HourList: Array<number> = []

  constructor(
    private modalService: BsModalService,
    private DeviceBehfa_Service: DeviceBehfaService,
    private ExpertCalibration_Service: ExpertCalibrationService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Alertify_Service: AlertifyService
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.HourList = Array(24).fill(1).map((x, i) => i);
    this.ScheduleForm = new FormGroup({
      id: new FormControl(),
      dsc: new FormControl(null),
      startHour: new FormControl("9", Validators.required),
      endHour: new FormControl("15", Validators.required),
      comment: new FormControl("0", Validators.required),
    })

  }


  //#region Calibration Technician

  ShowDelete_Schedule: boolean = false

  Set_ShowDelete_Schedule() {
    this.ShowDelete_Schedule = !this.ShowDelete_Schedule
  }


  ScheduleForm: FormGroup
  Schedule_DataList: Array<LetterRequestCustomer_Schedule_Interface> = []


  get_ScheduleForm_startHour() {
    return this.ScheduleForm.get('startHour') as FormControl;
  }

  get_ScheduleForm_endHour() {
    return this.ScheduleForm.get('endHour') as FormControl;
  }

  get_ScheduleForm_Dsc() {
    return this.ScheduleForm.get('dsc') as FormControl;
  }

  get_ScheduleForm_Comment() {
    return this.ScheduleForm.get('comment') as FormControl;
  }

  ScheduleForm_Submit() {
    var Checker: boolean = false

    var checker_Persian: string = ''
    for (let detail of this.Schedule_DataList) {
      if (detail.persianDate == this.inner_Record.persianDate && detail.del == false) {
        Checker = true
        break
      }
    }

    if (Checker) {
      this.Alertify_Service.ErrorMessage("The comment date is already in the list.")
    }
    else {
      var temp: LetterRequestCustomer_Schedule_Interface = Empty_LetterRequestCustomer_Schedule_Interface()
      temp.persianDate = this.inner_Record.persianDate
      temp.dsc = this.get_ScheduleForm_Dsc().value
      temp.startDate = Number(this.get_ScheduleForm_startHour().value)
      temp.endDate = Number(this.get_ScheduleForm_endHour().value)
      temp.comment = Number(this.get_ScheduleForm_Comment().value)
      temp.del = false
      temp.expert = []
      this.Schedule_DataList.push(temp)

      this.Alertify_Service.SuccessMessage('The information was saved successfully.')
    }
  }

  ScheduleForm_Delete(id) {
    this.Schedule_DataList[id].del = true
    this.Alertify_Service.SuccessMessage(" Deleted successfully.")
  }

  modalRef_ExpertCalibration: any;
  Procssing_ExpertCalibration: boolean = false
  Proccessing_Schedule: LetterRequestCustomer_Schedule_Interface = Empty_LetterRequestCustomer_Schedule_Interface()

  openModal_ExpertCalibration(template: TemplateRef<any>, item: LetterRequestCustomer_Schedule_Interface) {
    this.modalRef_ExpertCalibration = this.modalService.show(template);
    this.Proccessing_Schedule = item
  }

  ExpertCalibrationpage: number = 0;
  Filter_Familly: string = ''
  Filter_Area: string = ''

  Change_Filter() {
    this.ExpertCalibrationpage = 0
  }

  ReadData_ExpertCalibration() {
    this.Procssing_ExpertCalibration = true

    this.ExpertCalibration_Service.GetActiveList(this.Token, false, true, true).subscribe(
      data => {
        this.DataList_ExpertCalibration = data
        this.Procssing_ExpertCalibration = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  DataList_ExpertCalibration: Array<ExpertCalibration_Interface> = []

  Set_Selected_ExpertCalibration_Record(item: ExpertCalibration_Interface) {


    var Chekcer: boolean = false
    for (let detail of this.Proccessing_Schedule.expert) {
      if (detail.id == item.id && detail.del == false) {
        Chekcer = true
        break
      }
    }

    if (Chekcer) {
      this.Alertify_Service.ErrorMessage("The selected calibration technician is already in the list.")
    }
    else {

      item.del = false
      item.id_temp = 0

      this.Proccessing_Schedule.expert.push(item)
      //this.modalRef_ExpertCalibration.hide()
    }

  }

  ExpertCalibration_Delete(id, item: LetterRequestCustomer_Schedule_Interface) {
    item.expert[id].del = true
    this.Alertify_Service.SuccessMessage(" Deleted successfully.")
  }

  ExpertCalibration_Visible(item: ExpertCalibration_Interface) {

    this.LetterRequestCustomer_Service.SetLetterRequestCustomerExpertsVisible(this.Token, item.id_temp).subscribe(
      data => {
        item.visible = !item.visible
        this.Alertify_Service.SuccessMessage("The change was applied successfully.")
      }
    )

  }

  DeviceBehfa_Delete(id, item: LetterRequestCustomer_Schedule_Interface) {
    item.deviceBehfa[id].del = true
    this.Alertify_Service.SuccessMessage(" Deleted successfully.")
  }


  Change_Seleted_ExpertCalibration_Record(Record: LetterRequestCustomer_Schedule_Interface, indexer: number) {
    for (let item of Record.expert) {
      if (item.del == false) {
        item.seleted = false
      }
    }
    Record.expert[indexer].seleted = true
  }

  //#endregion

  //#region  Device Behfa

  modalRef_DeviceBehfa: any;
  openModal_DeviceBehfa(template: TemplateRef<any>, item: LetterRequestCustomer_Schedule_Interface) {
    this.modalRef_DeviceBehfa = this.modalService.show(template);
    this.Proccessing_Schedule = item
  }

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface) {
    var Chekcer: boolean = false
    for (let detail of this.Proccessing_Schedule.deviceBehfa) {
      if (detail.id == item.id && detail.del == false) {
        Chekcer = true
        break
      }
    }

    if (Chekcer) {
      this.Alertify_Service.ErrorMessage("The selected Behfa equipment is already in the list.")
    }
    else {
      item.del = false
      item.id_temp = 0

      this.Proccessing_Schedule.deviceBehfa.push(item)
      ///this.modalRef_DeviceBehfa.hide()
    }


  }

  //#endregion

  //#region LetterRequestCustomer

  modalRef_LetterRequestCustomer: any;
  Procssing_LetterRequestCustomer: boolean = false
  Search_persianDate_LetterRequestCustomer: String = ''
  Search_code_LetterRequestCustomer: String = ''
  Search_customer_LetterRequestCustomer: String = ''

  openModal_LetterRequestCustomer(template: TemplateRef<any>) {
    this.modalRef_LetterRequestCustomer = this.modalService.show(template);
  }

  Selected_DataList_LetterRequestCustomer: LetterRequestCustomer_List_Interface = Empty_LetterRequestCustomer_List_Interface()
  DataList_LetterRequestCustomer: Array<LetterRequestCustomer_List_Interface> = []

  ReadData_LetterRequestCustomer() {
    this.Procssing_LetterRequestCustomer = true

    this.LetterRequestCustomer_Service.GetLetterRequestCustomerSchduleForm(this.inner_Record.persianDate, this.Token).subscribe(
      data => {
        this.DataList_LetterRequestCustomer = data
        this.Procssing_LetterRequestCustomer = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )

  }


  Set_Selected_LetterRequestCustomer(item: LetterRequestCustomer_List_Interface) {
    this.Selected_DataList_LetterRequestCustomer = item
    this.modalRef_LetterRequestCustomer.hide()
  }

  //#endregion

  InProccessing: boolean = false
  canEditMore: boolean = false
  SubmitAddNewLetter() {

    var indexerSchdule: number = 0
    var chegerSchdule: boolean = false
    for (let item of this.Schedule_DataList) {
      if (item.del == false) {
        var Counter: number = 0
        for (let itemExp of item.expert) {
          if (itemExp.del == false) {
            Counter++
          }
        }

        if (Counter == 0) {
          chegerSchdule = true
          break;
        }

      }

      indexerSchdule++
    }


    var indexerSchdule_Super: number = 0
    var chegerSchdule_Super: boolean = false
    for (let item of this.Schedule_DataList) {
      if (item.del == false) {
        var Counter: number = 0
        for (let itemExp of item.expert) {
          if (itemExp.seleted == true && itemExp.del == false) {
            Counter++
          }
        }

        if (Counter == 0) {
          chegerSchdule_Super = true
          break;
        }
      }


      indexerSchdule_Super++
    }




    if (this.Schedule_DataList.length == 0) {
      this.Alertify_Service.ErrorMessage("Add at least one date.")
    }
    else if (chegerSchdule) {
      this.Alertify_Service.ErrorMessage("Row " + (indexerSchdule + 1) + " has no assigned calibration technician.")
    }
    else if (chegerSchdule_Super) {
      this.Alertify_Service.ErrorMessage("Row " + (indexerSchdule_Super + 1) + " has no assigned supervisor.")
    }

    else {






      var temp: Letter_Interface = Empty_Letter_Interface()
      temp.id = Number(this.Selected_DataList_LetterRequestCustomer.id)



      this.InProccessing = true
      this.LetterRequestCustomer_Service.AddEditSchduleForm(
        temp,
        this.Schedule_DataList,
        [],
        false,
        this.Token).subscribe(
          data => {

            if (data.id == -1) {
              this.Alertify_Service.ErrorMessage(data.dsc + '')
            }
            else {
              this.Alertify_Service.SuccessMessage("The information was saved successfully.")
            }

            this.InProccessing = false
            this.canEditMore = true
            this.modalRef.hide()
          }
        )
    }
  }

  modalRef:any
  openModal_Code(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);

  }



}
